import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

export default class extends Controller {
  static values = {
    noResults: String,
    // { "<option value>": "бухгалтер облік …" } — a hidden search index, never displayed. Only the
    // filter's specialization dropdown carries one.
    synonyms: Object
  }

  connect () {
    this.#indexSynonyms()
    this.selectInstance = new TomSelect(this.element, {
      allowEmptyOption: false,
      closeAfterSelect: true,
      // TomSelect stops after 50 options of its own accord, with nothing to say that it has. The
      // board draws only the tags a published vacancy carries, which is fewer today — but the
      // vocabulary behind it is 177, and a silent truncation is the same defect either way.
      maxOptions: null,
      // Makes the `syn` field #indexSynonyms writes searchable alongside the visible title.
      searchField: ['text', 'syn'],
      onItemAdd: () => this.selectInstance.blur(),
      ...this.#localisedEmptyMessage()
    })
  }

  // Writes each option's synonyms onto the option as `data-syn`, BEFORE TomSelect is constructed:
  // it copies the whole of `option.dataset` onto its own option object once, at construction
  // (`getSettings.js`, `readData`), so anything written afterwards is never seen. The twin of
  // select-multiple-controller's method of the same name — see its comment for why this is a
  // plain data attribute rather than the `dataAttr` setting.
  #indexSynonyms () {
    if (!this.hasSynonymsValue) return

    for (const option of this.element.options) {
      const words = this.synonymsValue[option.value]

      if (words) option.dataset.syn = words
    }
  }

  // Opt-in: TomSelect's own empty line is the English "No results found", which is wrong on a
  // Ukrainian page. A caller that passes data-select-no-results-value gets its own wording;
  // one that does not is left on TomSelect's default, unchanged.
  //
  // Built with textContent rather than a template literal — the value is ours, from a locale
  // file, but this widget's whole point is a box a stranger types into.
  #localisedEmptyMessage () {
    if (!this.hasNoResultsValue) return {}

    const text = this.noResultsValue

    return {
      render: {
        no_results: () => {
          const element = document.createElement('div')

          element.className = 'no-results'
          element.textContent = text

          return element
        }
      }
    }
  }

  disconnect () {
    this.selectInstance?.destroy()
  }
}
